/* DG_CART_CHECKOUT_GATE_V4: retain server verification; repair cart-only prompt and response handling. */
(function () {
  'use strict';
  if (window.DestGlowCartGate) return;
  function init() {
    var config = window.turnstileThemeConfig || {};
    if (config.designMode || (window.Shopify && window.Shopify.designMode)) return;
    if (config.scope !== 'cart-checkout-only' || !config.siteKey || !config.workerUrl) return;
    var nativeFetch = window.fetch;
    var storageKey = config.storageKey || 'turnstile_cart_checkout_passed_v4';
    var passedInMemory = false;
    var pending = null;
    var resolvePending = null;
    var loader = null;
    var widgetId = null;
    var verifying = false;
    var queuedIntent = false;
    var trigger = null;
    var dialog = null;
    var status = null;
    var widget = null;
    var retry = null;
    function passed() {
      if (passedInMemory) return true;
      try { return sessionStorage.getItem(storageKey) === '1'; } catch (error) { return false; }
    }
    function remember() {
      passedInMemory = true;
      try { sessionStorage.setItem(storageKey, '1'); } catch (error) {}
    }
    function finish(success) {
      var resolve = resolvePending;
      resolvePending = null;
      pending = null;
      if (success) remember();
      if (dialog && dialog.open) dialog.close();
      if (trigger && trigger.isConnected && typeof trigger.focus === 'function') trigger.focus();
      if (resolve) resolve(success);
    }
    function buildDialog() {
      if (dialog) return;
      dialog = document.createElement('dialog');
      dialog.id = 'DestGlowSecurityGate';
      dialog.setAttribute('aria-labelledby', 'DestGlowSecurityTitle');
      dialog.setAttribute('aria-describedby', 'DestGlowSecurityStatus');
      var heading = document.createElement('h2');
      heading.id = 'DestGlowSecurityTitle';
      heading.textContent = 'Verify to continue';
      status = document.createElement('p');
      status.id = 'DestGlowSecurityStatus';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      widget = document.createElement('div');
      widget.id = 'DestGlowSecurityWidget';
      retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'button button--small';
      retry.textContent = 'Retry security check';
      retry.hidden = true;
      retry.addEventListener('click', renderCheck);
      var cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.className = 'button button--small button--secondary';
      cancel.textContent = 'Continue browsing';
      cancel.addEventListener('click', function () { finish(false); });
      dialog.addEventListener('cancel', function (event) { event.preventDefault(); finish(false); });
      dialog.append(heading, status, widget, retry, cancel);
      document.body.appendChild(dialog);
    }
    function apiReady() {
      if (window.turnstile && typeof window.turnstile.render === 'function') return Promise.resolve(window.turnstile);
      if (loader) return loader;
      loader = new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[src*="challenges.cloudflare.com/turnstile/v0/api.js"]');
        var attempts = 0;
        var timer = window.setInterval(function () {
          if (window.turnstile && typeof window.turnstile.render === 'function') {
            window.clearInterval(timer);
            resolve(window.turnstile);
          } else if (++attempts >= 150) {
            window.clearInterval(timer);
            reject(new Error('security-api-unavailable'));
          }
        }, 100);
        if (!existing) {
          var script = document.createElement('script');
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true;
          script.onerror = function () {
            window.clearInterval(timer);
            script.remove();
            reject(new Error('security-script-unavailable'));
          };
          document.head.appendChild(script);
        }
      }).catch(function (error) { loader = null; throw error; });
      return loader;
    }
    function verifyToken(token) {
      if (!token || typeof token !== 'string') return Promise.resolve(false);
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = controller ? window.setTimeout(function () { controller.abort(); }, 12000) : null;
      return nativeFetch.call(window, config.workerUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: token, expectedHostname: location.hostname, expectedAction: 'cart_checkout' }),
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        return response.text().then(function (body) {
          // Only explicit JSON verification success grants access. A generic "Accepted" response does not.
          try { var data = JSON.parse(body); return Boolean(response.ok && data && data.success === true); }
          catch (error) { return false; }
        });
      }).catch(function () { return false; }).finally(function () { if (timer) window.clearTimeout(timer); });
    }
    function renderCheck() {
      if (!pending || verifying) return;
      status.textContent = 'Loading security check...';
      retry.hidden = true;
      apiReady().then(function (api) {
        if (!pending) return;
        if (widgetId !== null) { api.reset(widgetId); status.textContent = 'Please complete the security check.'; return; }
        widgetId = api.render(widget, {
          sitekey: config.siteKey, action: 'cart_checkout', size: 'flexible',
          callback: function (token) {
            if (!pending || verifying) return;
            verifying = true;
            status.textContent = 'Verifying security check...';
            verifyToken(token).then(function (success) {
              verifying = false;
              if (!pending) return;
              if (success) { finish(true); return; }
              status.textContent = 'Verification was not confirmed. Please retry the security check.';
              retry.hidden = false;
            });
          },
          'expired-callback': function () {
            if (pending) { status.textContent = 'Security check expired. Please try again.'; retry.hidden = false; }
          },
          'error-callback': function () {
            if (pending) { status.textContent = 'Security check could not load. Please retry.'; retry.hidden = false; }
          }
        });
        status.textContent = 'Please complete the security check.';
      }).catch(function () {
        if (pending) { status.textContent = 'Security verification is unavailable. Please retry or continue browsing.'; retry.hidden = false; }
      });
    }
    function ensureVerified() {
      if (passed()) return Promise.resolve(true);
      if (pending) return pending;
      buildDialog();
      trigger = document.activeElement;
      pending = new Promise(function (resolve) { resolvePending = resolve; });
      if (!dialog.open) dialog.showModal();
      renderCheck();
      return pending;
    }
    function protectedUrl(value) {
      try {
        var url = new URL(value, location.href);
        return url.origin === location.origin &&
          (/\/cart(?:\/(?:add|change|update|clear))?(?:\.js)?\/?$/i.test(url.pathname) || /\/checkouts?(?:\/|$)/i.test(url.pathname));
      } catch (error) { return false; }
    }
    function protectedControl(target) {
      if (!target || !target.closest) return null;
      var link = target.closest('a[href]');
      if (link) {
        try { var path = new URL(link.href, location.href).pathname; return /\/checkouts?(?:\/|$)/i.test(path) && protectedUrl(link.href) ? link : null; }
        catch (error) { return null; }
      }
      var button = target.closest('button, input[type="submit"]');
      if (!button) return null;
      var form = button.form;
      var type = (button.getAttribute('type') || 'submit').toLowerCase();
      return type === 'submit' && form && protectedUrl(button.getAttribute('formaction') || form.action) ? button : null;
    }
    document.addEventListener('click', function (event) {
      if (passed()) return;
      var control = protectedControl(event.target);
      if (!control || control.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (queuedIntent) return;
      queuedIntent = true;
      ensureVerified().then(function (success) {
        queuedIntent = false;
        if (success && control.isConnected) control.click();
      });
    }, true);
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (passed() || !form || !protectedUrl(form.action)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (queuedIntent) return;
      queuedIntent = true;
      var submitter = event.submitter;
      ensureVerified().then(function (success) {
        queuedIntent = false;
        if (success && form.isConnected) {
          if (submitter && submitter.isConnected) form.requestSubmit(submitter);
          else form.requestSubmit();
        }
      });
    }, true);
    if (typeof nativeFetch === 'function') {
      // Existing security interception remains narrowly scoped to same-origin cart/checkout writes.
      window.fetch = function (input, init) {
        var args = arguments;
        var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        var url = typeof input === 'string' ? input : (input && input.url) || String(input);
        if (!passed() && method !== 'GET' && method !== 'HEAD' && protectedUrl(url)) {
          return ensureVerified().then(function (success) {
            if (!success) throw new Error('DestGlow security verification cancelled or not completed');
            return nativeFetch.apply(window, args);
          });
        }
        return nativeFetch.apply(this, args);
      };
    }
    window.DestGlowCartGate = { version: 4 };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
